
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TabPerformanceMixin extends Vue {
    @Prop({ default: false }) isSixAgentActive!: boolean;
    @Prop({ default: false }) isPreload!: boolean;

    private dataCache: Map<string, any> = new Map();

    /**
     * Get performance threshold based on SiX Agent state
     */
    get performanceThreshold() {
        return this.isSixAgentActive ? 2000 : 1000;
    }

    /**
     * Check if we should use cached data
     */
    get shouldUseCache() {
        return this.isSixAgentActive || this.isPreload;
    }

    /**
     * End performance monitoring and report results
     */
    endPerformanceMonitoring() {
        // Performance monitoring placeholder for future implementation
    }

    /**
     * Cache data for performance optimization
     */
    cacheData(key: string, data: any) {
        if (this.shouldUseCache) {
            this.dataCache.set(key, {
                data,
                timestamp: Date.now()
            });
        }
    }

    /**
     * Retrieve cached data if available and not expired
     */
    getCachedData(key: string, maxAge = 300000) { // 5 minutes default
        if (!this.shouldUseCache) {
            return null;
        }

        const cached = this.dataCache.get(key);
        if (!cached) {
            return null;
        }

        const age = Date.now() - cached.timestamp;
        if (age > maxAge) {
            this.dataCache.delete(key);
            return null;
        }

        return cached.data;
    }

    /**
     * Clean up cache on destroy
     */
    beforeDestroy() {
        this.dataCache.clear();
    }
}
